import React, { useRef } from 'react'
import { FaAngleDown } from 'react-icons/fa'
import styled from 'styled-components'
import { useToggle } from '../customHooks/useToggle'
import SkillItem from './SkillItem'

const Wrapper = styled.div`
    width: 250px;
    display: flex;
    flex-direction: column;
    .skill__group {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .skill__header {
            display: flex;
            flex-direction: column;
            .skill__title {
                font-size: 24px;
                font-weight: 600;
            }
        }
    }
    .icon {
        transition: .6s ease-in-out;
        .angle {
            font-size: 36px;
        }
    }
    .skill__itens {
        transition: .6s ease-in-out;
    }
`
interface SkillCardProps {
    title: string
    redes: string[][]
}

function SkillCard({title, redes}: SkillCardProps) {

    const card = useRef<HTMLDivElement>(null)
    const angle = useRef<HTMLDivElement>(null)
    const [isClicked, setIsClicked] = useToggle(true)

    const HandleClick = () => {

        if (card.current && angle.current) {
            if (isClicked === false) {
                card.current.style.opacity ='1'
                card.current.style.maxHeight ='500px'
                angle.current.style.transform = 'rotate(360deg)'
            } else {
                card.current.style.opacity ='0'
                card.current.style.maxHeight ='0'
                angle.current.style.transform = 'rotate(180deg)'
            }
        }

        setIsClicked()

    }

    return (
        <Wrapper>
            <div className="skill__group">
                <div className="skill__header">
                    <p className="skill__title">{title}</p>
                </div>
                <div className="icon" ref={angle} onClick={HandleClick}>
                    <FaAngleDown className="angle" />
                </div>
            </div>
            <div className="skill__itens" ref={card}>
                {redes.map((rede: string[], index: number) => (
                <SkillItem key={index} rede={rede} />
                ))}
            </div>
        </Wrapper>
    );
}

export default SkillCard;